import { useState } from 'react'
import { useQuery } from 'react-query'

import type { AgentInsightService } from 'features/trend-detection/features/insight-agent/service'
import type { AgentInsightFeedItem } from 'features/trend-detection/features/insight-agent/types'

const PAGE_SIZE = 15

export interface UseAgentInsightFeedResult {
  items: AgentInsightFeedItem[]
  totalCount: number
  totalPages: number
  page: number
  isLoading: boolean
  onPageChange: (page: number) => void
}

export interface UseAgentInsightFeedArgs {
  service: AgentInsightService
  projectId: string | null
  enabled: boolean
}

/** One page of the project's insight-agent feed. */
export function useAgentInsightFeed({
  service,
  projectId,
  enabled,
}: UseAgentInsightFeedArgs): UseAgentInsightFeedResult {
  const [page, setPage] = useState(1)

  const { data, isLoading } = useQuery({
    queryKey: ['agent-insight-feed', projectId, page],
    queryFn: () => service.listInsights(projectId!, page, PAGE_SIZE),
    enabled: enabled && Boolean(projectId),
    refetchOnWindowFocus: false,
  })

  return {
    items: data?.items ?? [],
    totalCount: data?.total_count ?? 0,
    totalPages: data?.total_pages ?? 0,
    page,
    isLoading,
    onPageChange: setPage,
  }
}
